<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold" v-html="title" />
    <div class="col-12 col-md-8 col-xl-9">
      <div class="d-flex flex-column align-items-start align-items-xl-start flex-sm-wrap flex-sm-row">
        <button type="button"
              v-for="(item, index) in items"
              :key="index"
              :class="['btn btn-sm btn-outline-filter', filterUiState('suspendedCeiling', item.value)]"
              v-on:click="selectValue(item.value)">{{ item.title }}</button>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionSuspendedCeiling',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'Unterdecke',
      items: [
        { title: 'Lattung 24 mm', value: 'ba-24' },
        { title: 'Federschiene 25 mm', value: 'f-25' },
        { title: 'Federschiene 27 mm', value: 'f-27' },
        { title: 'U-Abhänger schallentkoppelt 80 mm', value: 'uas-80' },
        { title: 'ohne', value: null }
      ]
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      const result = this.items.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('suspendedCeiling', value)

      this.$gtm.trackEvent({
        event: 'filter',
        category: this.title,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: value !== null ? Number(value.split('-')[1]) : null
      })

      this.$store.dispatch('filter/setValue', {
        name: 'suspendedCeiling',
        title: this.title + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
